import { get, merge } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc MemberManagementWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberManagementWidgetService } from 'services/memberManagementWidget';
 *
 * // create service instance and send/cancel request
 * const memberManagementWidgetService = new MemberManagementWidgetService();
 * const result = await memberManagementWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberManagementWidgetService.cancel(); // cancel an active request
 */
export class MemberManagementWidgetService extends HttpService {

    // fetch call control widget data
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );

        // get ongoing callType info from the redux store
        const callType = get( store.getState()[ REDUCER.CALL_STATE ], 'callType', null );

        // get ongoing callerType info from the redux store
        const callerType = get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( {}, data, {
                    context: {
                        callId,
                        callType,
                        callerType,
                        module: 'dashboard'
                    },
                } ),
            } );

            // extract widgets from the response
            const visibility = get( response, 'body.component.visibility', {} );
            const onMountActions = get( response, 'body.component.structure.onMountActions', [] );
            const widgets = get( response, 'body.component.structure.widgets', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    onMountActions: getVisibleItems( onMountActions, visibility ),
                    widgets: getVisibleItems( widgets, visibility ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // generate off-call action-list log when member-management widget mounts
    async generateActionListLog( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( {}, data, {} ),
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: null,
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
